import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class EvlendirmeBasvuruAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "EvlendirmeBasvuru";
        super(baseUrl);
    }

    readAllNikahSalonu() {
        return this.get("ReadAllNikahSalonu");
    }

    readAllEvlenmeTur() {
        return this.get("ReadAllEvlenmeTur");
    }

    readAllEvlenmeYeriTur() {
        return this.get("readAllEvlenmeYeriTur");
    }

    readAllNikahSaatBySalonTarih(request:ReadAllNikahSaatBySalonTarihRequest) {
        return this.post("ReadAllNikahSaatBySalonTarih",request);
    }

    readAllEvlBeyanForOnay(request:ReadAllEvlBeyanForOnayRequest) {
        return this.post("ReadAllEvlBeyanForOnay",request);
    }

    nufusCüzdanVerilis() {
        return this.get("NufusCuzdanVerilis");
    }

    ortDinlerFind() {
        return this.get("OrtDinlerFind");
    }

    ortMeslekList() {
        return this.get("OrtMeslekList");
    }

    ortOgrenimDurumu() {
        return this.get("OrtOgrenimDurumu");
    }

    evlBeyanSave(request: EvlBeyanSaveRequest) {
        return this.post("EvlBeyanSave", request,true);
    }

}
export default new EvlendirmeBasvuruAPI();

class ReadAllNikahSaatBySalonTarihRequest {
    salon?: number;
    tarih?: Date;

    constructor(
        salon?: number,
        tarih?: Date
    ) {
        this.salon=salon;
        this.tarih=tarih;
    }
}
export { ReadAllNikahSaatBySalonTarihRequest };

class ReadAllEvlBeyanForOnayRequest {
    nikahSalonId?: number;
    onayKod?: String;
    pTarİlk?: Date;
    pTarSon?: Date;

    constructor(
        nikahSalonId?: number,
        onayKod?: String,
        pTarİlk?: Date,
        pTarSon?: Date
    ) {
        this.nikahSalonId=nikahSalonId;
        this.onayKod=onayKod;
        this.pTarİlk=pTarİlk;
        this.pTarSon=pTarSon;
    }
}
export { ReadAllEvlBeyanForOnayRequest };

class EvlBeyanSaveRequest {
    VRowid?: string;
    VYil?: number;
    VDefterNo?: number;
    VSiraNo?: number;
    VEvlenmeTarihi?: Date;
    VEvlenmeSaati?: string;
    VEvlenmeYeriUlke?: number;
    VEvlenmeYeriIlIlce?: string;
    VYeriBucakKoy?: string;
    VEvlenmeTuru?: number;
    VEvlenmeYeri?: number;
    VTescilNo?: string;
    VTescilTarihi?: Date;
    VOzelKutukSira?: string;
    VBildirimDuzenleyen?: string;
    VBildirimOnaylayan1?: string;
    VIslemeKoyanNufusIdare?: string;
    VAileIcinGondNufusIdaresi?: string;
    VNisanTarihi?: Date;
    VAileCuzdanNo?: string;
    VKKimlikNo?: number;
    VKKimlikSeri?: string;
    VKVatandaslikNo?: number;
    VKSoyadi?: string;
    VKAdi?: string;
    VKBabaAdi?: string;
    VKBabaSiraNo?: string;
    VKAnneAdi?: string;
    VKBabaSagOlu?: string;
    VKAnneSagOlu?: string;
    VKAnneSiraNo?: string;
    VKDogumYeri?: string;
    VKDogumYeriUlke?: string;
    VKDogumYeriAciklamasi?: string;
    VKDogumTarihi?: Date;
    VKMedeniDurumu?: string;
    VKDini?: string;
    VKUyrugu?: string;
    VKNufusaKayitliYer?: string;
    VKNufusaKayitliMahal?: string;
    VKCiltNo?: string;
    VKAileSiraNo?: string;
    VKNufusSiraNo?: string;
    VKVerildigiNufusIdaresi?: string;
    VKNufusCuzdanVerilisNeden?: string;
    VKNufusCuzdanKayitNo?: string;
    VKNufusCuzdanVerildigiTar?: Date;
    VKAkrabalikDerecesi?: string;
    VKSaglikRaporuIstiyorMu?: string;
    VKEvlenmeYasagiVarMi?: string;
    VKKazaiEvlenmeYasagi?: string;
    VKEvlenmeIzinBelgesi?: string;
    VKEvlenmeManiHastaMi?: string;
    VKEvlenmeEhliyetBelgesi?: string;
    VKOncekiKizlikSoyadi?: string;
    VKOgrenimDurumu?: string;
    VKKacDefaEvlenmisti?: number;
    VKBosanmaTarihi?: Date;
    VKOncekiEvlilikCocukSayis?: number;
    VKBakmaklaYukumluCocukSay?: number;
    VKMeslekKodu?: string;
    VKAdresBilgisi1?: string;
    VKAdresBilgisi2?: string;
    VKAdresBilgisi3?: string;
    VKHastaneAdi?: string;
    VKHastaneTarihi?: Date;
    VKHastaneDosyaNo?: string;
    VKDoktorSicilNo?: string;
    VKDoktorAdi?: string;
    VKDoktorBolumu?: string;
    VKVarsaVasiAdi?: string;
    VKVarsaVasiYakinligi?: string;
    VKMahkemeAdi?: string;
    VKMahkemeTarihi?: Date;
    VKMahkemeKararNo?: string;
    VKEsininVatandasliginaGecti?: string;
    VKTescIcinGonNufusIdares?: string;
    VKKutugeIlkTescilTarihi?: Date;
    VKBeyannameCiltNo?: string;
    VEKimlikNo?: number;
    VEKimlikSeri?: string;
    VEVatandaslikNo?: number;
    VESoyadi?: string;
    VEAdi?: string;
    VEBabaAdi?: string;
    VEAnneAdi?: string;
    VEBabaSagOlu?: string;
    VEBabaSiraNo?: string;
    VEAnneSagOlu?: string;
    VEAnneSiraNo?: string;
    VEDogumYeri?: string;
    VEDogumYeriUlke?: string;
    VEDogumYeriAciklamasi?: string;
    VEDogumTarihi?: Date;
    VEMedeniDurumu?: string;
    VEDini?: string;
    VEUyrugu?: string;
    VENufusaKayitliYer?: string;
    VENufusaKayitliMahal?: string;
    VECiltNo?: string;
    VEAileSiraNo?: string;
    VENufusSiraNo?: string;
    VEVerildigiNufusIdaresi?: string;
    VENufusCuzdanVerilisNeden?: string;
    VENufusCuzdanKayitNo?: string;
    VENufusCuzdanVerildigiTar?: Date;
    VEAkrabalikDerecesi?: string;
    VESaglikRaporuIstiyorMu?: string;
    VEEvlenmeYasagiVarMi?: string;
    VEKazaiEvlenmeYasagi?: string;
    VEEvlenmeIzinBelgesi?: string;
    VEEvlenmeManiHastaMi?: string;
    VEEvlenmeEhliyetBelgesi?: string;
    VEAskerlikCuzdanNo?: string;
    VEOgrenimDurumu?: string;
    VEKacDefaEvlenmisti?: number;
    VEBosanmaTarihi?: Date;
    VEOncekiEvlilikCocukSayis?: number;
    VEBakmaklaYukumluCocukSay?: number;
    VEMeslekKodu?: string;
    VEAdresBilgisi1?: string;
    VEAdresBilgisi2?: string;
    VEAdresBilgisi3?: string;
    VEHastaneAdi?: string;
    VEHastaneTarihi?: Date;
    VEHastaneDosyaNo?: string;
    VEDoktorSicilNo?: string;
    VEDoktorAdi?: string;
    VEDoktorBolumu?: string;
    VEVarsaVasiAdi?: string;
    VEVarsaVasiYakinligi?: string;
    VEMahkemeAdi?: string;
    VEMahkemeTarihi?: Date;
    VEMahkemeKararNo?: string;
    VEEsininVatandasliginaGect?: string;
    VETescIcinGonNufusIdares?: string;
    VEKutugeIleTescilTarihi?: Date;
    VEBeyannameCiltNo?: string;
    VEvlenmeTescilTarihi?: Date;
    VEvlenmeTescilNo?: string;
    VBildirimDuzenlenmeYeri?: string;
    VBildirimDuzenleyenTarih?: Date;
    VBildirimOnaylayan1Tarih?: Date;
    VAileKutuguTescilTarihi?: Date;
    VAileKutuguTescilNo?: string;
    VKutugeIsleyen?: string;
    VKutugeIsleyenTarih?: Date;
    VBildirimOnaylayan2?: string;
    VBildirimOnaylayan2Tarih?: Date;
    VFormuKontrolEden?: string;
    VFormuKontrolEdenTarih?: Date;
    VVeriGirisiYapan?: string;
    VVeriGirisiYapanTarih?: Date;
    VCiktiKontroluYapan?: string;
    VCiktiKontrolYapanTarih?: Date;
    VKayitTarihi?: Date;
    VKaydeden?: string;
    VBasvuruYili?: number;
    VBasvuruNo?: number;
    VBasvuruTarihi?: Date;
    VAciklama?: string;
    VKDogumYili?: number;
    VEDogumYili?: number;
    VKBabaSoyadi?: string;
    VKAnaSoyadi?: string;
    VEBabaSoyadi?: string;
    VEAnaSoyadi?: string;
    VMIlIlceKodu?: string;
    VMMahalleAdi?: string;
    VMCadSokAdi?: string;
    VMSiteBlokAdi?: string;
    VMDiskapiNo?: string;
    VMIckapiNo?: string;
    VMGelisTrh?: Date;
    VMPostaKodu?: string;
    VKSosyalGuv?: string;
    VESosyalGuv?: string;
    VKSosyalKodu?: string;
    VESosyalKodu?: string;
    VKKocaBsn?: string;
    VKOncekiSoyadiKullanacakmi?: string;
    VEvlenmeYeriTuru?: number;
    VMTelefonNo?: string;
    VKTelefonNo?: string;
    VETelefonNo?: string;
    VEVerildigiNufIlYaz?: string;
    VKVerildigiNufIlYaz?: string;
    VENufusaKayitliIlYaz?: string;
    VKNufusaKayitliIlYaz?: string;
    VEDogumYeriIlYaz?: string;
    VKDogumYeriIlYaz?: string;
    VID?: number;
    VDurum?: string;
    VKMahalleKodu?: number;
    VKCaddeSokakKodu?: number;
    VKKapiNo?: string;
    VKAltKapiNo?: string;
    VKDaireNo?: string;
    VKAltDaireNo?: string;
    VKBinaNo?: string;
    VKBagimsizNo?: string;
    VEMahalleKodu?: number;
    VECaddeSokakKodu?: number;
    VEKapiNo?: number;
    VEAltKapiNo?: string;
    VEDaireNo?: number;
    VEAltDaireNo?: string;
    VEBinaNo?: string;
    VEBagimsizNo?: string;
    VMMahalleKodu?: number;
    VMCaddeSokakKodu?: number;
    VMAltKapiNo?: string;
    VMAltDaireNo?: string;
    VMBinaNo?: string;
    VMBagimsizNo?: string;
    VKIlIlce?: string;
    VEIlIlce?: string;
    VKYilYaz?: string;
    VEYilYaz?: string;
    VMUlke?: string;
    VEEmail?: string;
    VEAlanKodu?: string;
    VECepNo?: string;
    VKEmail?: string;
    VKAlanKodu?: string;
    VKCepNo?: string;
    VTuru?: string;
    VKutuNo?: string;
    VDosyaNo?: string;
    VENikahSahidi?: string;
    VKNikahSahidi?: string;
    VEKanGrubu?: string;
    VKKanGrubu?: string;
    VEBaskaUlke?: string;
    VKBaskaUlke?: string;
    VEPasaport?: string;
    VKPasaport?: string;
    VTemp?: string;
    VIPAdres?: string;
    VImzaSahibi?: string;
    VOrtakIlYaz?: string;
    VKVelayet?: string;
    VEVelayet?: string;
    VEEAnneBabaIzin?: string;
    VKAnneBabaIzin?: string;
    VOrtBlg3AckCzdYazilsin?: string;
    VArsivId?: string;
    VKBaskaBelediyeIzniVarmi?: string;
    VEBaskaBelediyeIzniVarmi?: string;
    VCTMalAyriligi?: string;
    VCTPayMalAyriligi?: string;
    VCTMalOrtakligi?: string;
    VENikahSahidi1?: string;
    VKNikahSahidi1?: string;
    VENikahSahidiTc?: string;
    VKNikahSahidiTc?: string;
    VENikahSahidi1Tc?: string;
    VKNikahSahidi1Tc?: string;
    VDefterSayfaNo?: string;
    VCTIddetMuddetMahKarari?: string;
    VKCocukVatandaslikNoQt?: string;
    VIDdetMuddetKadinCocukCt?: string;
    VKCocukAdiCh?: string;
    VKCocukSoyadiCh?: string;
    VKCocukAnneAdiCh?: string;
}
export { EvlBeyanSaveRequest };
